/*
 * @Author: your name
 * @Date: 2021-10-27 14:57:32
 * @LastEditTime: 2021-10-29 10:40:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \wapquote\src\modules\select_nav\index.ts
 */
import merge from "lodash/merge";
declare var Hammer: any;

class Select {
  select_config: any = {}
  nowX: any = 0
  conf: any = {}
  constructor(options: any) {
    this.select_config = merge(this.select_config, options);
  }

  // 初始化 nav
  init() {
    let self = this;
    self.showSelect();
    self.bindFun();
  }

  //加载 nav
  showSelect() {
    let self = this;
    let container = $(`.${self.select_config.ele}`)
    let html = ``
    container.html('')
    self.select_config.navArr.forEach((val: any, index: number) => {
      html += `<span class="${val.isSelect ? 'select' : ''}" data-tab=${index}>${val.name}</span>`
    });
    container.html(`<div class='select-container'>${html}</div>`)
  }

  bindFun() {
    let self = this;
    let carousel: any = document.getElementsByClassName(`select-container`)[0];
    $(`.select-container span`).on('click', function (e) {
      self.select_config.onclick(self.select_config.navArr[$(this).data('tab')].value, $(this).data('tab'), $(this))
      $.each($(`.select-container`).find('span'), function (e) {
        $(this).removeClass("select");
      })
      $(this).addClass('select')
    })

    var allWidth: any = 0, showWidth: any = $(`.select-container`).width()

    $.each($(`.select-container span`), function () {
      allWidth += $(this).width()
      allWidth += 20
    })

    var options = {
      endX: 0,
      nowX: self.nowX,
      carousel: carousel,
      showWidth: showWidth,
      allWidth: allWidth
    }

    self.conf = options

    var hemmertime = new Hammer(carousel)
    hemmertime.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL });
    hemmertime.on('panstart', function (e: any) {
      carousel.style.transition = 'none';
    })
    hemmertime.on('panmove', function (e: any) {
      options.endX = e.deltaX
      let _moveX = options.nowX + options.endX
      if (_moveX > 0) {
        _moveX = 0
      }

      if (_moveX - options.showWidth + options.allWidth < 0) {
        _moveX = options.showWidth - options.allWidth
      }

      carousel.style.transform = 'translateX(' + Math.round(_moveX) + 'px)';
    }, false)
    hemmertime.on('panend', function (e: any) {
      options.nowX = options.endX + options.nowX;
      carousel.style.transition = 'transform .5s cubic-bezier(.17,.67,.84,.90)';
      self.setTransform(options)
      self.nowX = options.nowX
    })
  }

  setTransform(options: any) {
    // 滑动归位
    if (options.nowX > 0) {
      options.nowX = 0
    } else if (options.nowX + options.allWidth - options.showWidth < 0) {
      options.nowX = options.showWidth - options.allWidth
    } else {
    }
    options.carousel.style.transform = 'translateX(' + Math.round(options.nowX) + 'px)';
  }

  // 显示指定Slide
  goSlide(index: number) {
    let self = this
    $.each($(`.select-container`).find('span'), function (e, i) {
      $(this).removeClass("select");
      if ($(this).data('tab') == index) {
        $(this).addClass('select');
        let translateX: any = Number($('.select-container').css("transform").replace(/[^0-9\-,]/g, '').split(',')[4])
        translateX = translateX ? translateX : 0
        let _offset: any = $(this).offset()
        let moveX = -_offset.left + translateX;

        if (moveX > 0) {
          moveX = 0
        }

        if (moveX - self.conf.showWidth + self.conf.allWidth < 0) {
          moveX = self.conf.showWidth - self.conf.allWidth
        }
        self.conf.carousel.style.transition = 'transform .5s cubic-bezier(.17,.67,.84,.90)';
        self.conf.carousel.style.transform = 'translateX(' + Math.round(moveX) + 'px)';
        self.conf.nowX = moveX;
        self.nowX = moveX;
      }
    })
  }
}

export default Select